'use strict';

P = window.P || {};
P.S = P.S || new Search();

require('./vendor/pipllazy-0.1.0.js');

function Search() {
  var tracked_map_views = [];

  function setfilter(value, $nodes) {
    var $siblings = $nodes.siblings('.added');
    $nodes.val('');
    $siblings.attr('value', value);
    $siblings.removeAttr('disabled');
  }

  function removeFilter($nodes) {
    var $siblings = $nodes.siblings('.added');
    $siblings.attr('value', '');
    $siblings.attr('disabled', 'disabled');
  }

  function toggleView(e) {
    e.preventDefault();

    console.log(e);

    var $divs = $('div#advanced_search div.inputs');
    var $button = $(this);
    var currentVal = $button.html();
    $button.html($button.attr('data-alt'));
    $button.attr('data-alt', currentVal);

    if ($button.hasClass('more')) {
      $divs
        .slideDown()
        .children('input')
        .removeAttr('disabled');
    } else {
      $divs
        .not(':has(input[value!=""])')
        .not('.error')
        .slideUp()
        .children('input')
        .attr('disabled', 'disabled');
    }

    $button.toggleClass('more');
    $button.siblings('.even-more').toggle();

    if ($button.hasClass('more-advanced')) {
      $button.unbind('click');
    }

    return false;
  }

  function ShowMap(container, map_type, addressinfo) // addressinfo in "piplxml3/fields.py:Address::js_object()" format
  {
    var TRACKER_TYPE_MAP = 6;
    var TRACKER_TYPE_LINK = 8;
    var params, image_url;

    if (addressinfo) {
      container.data('addressinfo', addressinfo);
    } else {
      addressinfo = container.data('addressinfo');
    }

    // Calculate address level ("a" = 0 ... "co" = 5)
    var address_levels = ['apartment', 'house', 'street', 'city', 'state', 'country'];
    for (var address_level in address_levels)
      if (addressinfo[address_levels[address_level]]) {
        break;
      }

    // Set default map type
    if (!map_type) {
      map_type = address_level >= 3 ? 'roadmap' : 'satellite';
    }

    var settings = {
      roadmap: { dsid: 55480, zoom_levels: [16, 16, 15, 5, 5, 5] },
      satellite: { dsid: 55482, zoom_levels: [18, 18, 16, 5, 5, 5] },
      streetview: { dsid: 55486, zoom_levels: [2, 2, 2, 2, 2, 2] },
    };

    // Set optimized zoom level
    var zoom = settings[map_type].zoom_levels[address_level];

    // Set image width
    var width = 566;
    var $personPreviewContainer = container.parents('.person_preview_container');
    if ($personPreviewContainer.length) {
      width = $personPreviewContainer.hasClass('person_result') ? 503 : 577;
    }
    //        var width = container.closest("#profile_summary").length ? 520 : 420;

    if (map_type == 'streetview') {
      // Construct map parameters
      params = [
        'location=' + encodeURIComponent(addressinfo.display),
        'size=' + width + 'x262',
        'zoom=' + zoom,
        'pitch=0',
        'key=AIzaSyDfs49C1bDe8cNe_lQyzu0po29WUfE-OJ8',
      ];

      // Construct map image url
      image_url = 'https://maps.googleapis.com/maps/api/streetview?' + params.join('&');

      // Geocode address
      var latlng = [];
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: addressinfo.display }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var location = results[0].geometry.location;
          latlng = [location.lat(), location.lng()];
        }
      });
    } else {
      // Construct map parameters
      params = [
        'center=' + encodeURIComponent(addressinfo.display),
        'markers=' + encodeURIComponent('color:red|label:|=' + addressinfo.display),
        'zoom=' + zoom,
        'size=' + width + 'x262',
        'maptype=' + map_type,
        'key=AIzaSyDfs49C1bDe8cNe_lQyzu0po29WUfE-OJ8',
      ];

      // Construct map image url
      image_url = 'https://maps.googleapis.com/maps/api/staticmap?' + params.join('&');
    }

    // Tracking
    var dses = [
      settings[map_type].dsid,
      settings['roadmap'].dsid,
      settings['satellite'].dsid,
      settings['streetview'].dsid,
    ];
    var types = [TRACKER_TYPE_MAP, TRACKER_TYPE_LINK, TRACKER_TYPE_LINK, TRACKER_TYPE_LINK];

    // Hide street view if no street available
    if (address_level > 2) {
      dses.pop();
      types.pop();
    }

    Tracker(dses, types);

    // Construct map image and link
    container.empty().append(
      $('<a>', { target: '_blank' })
        .append(
          $('<img>', { src: image_url }).on('load', function() {
            container.find('.buttons').show();
          }),
        )
        .on('click', function() {
          var map_type = $(this)
            .closest('.map-container')
            .find('li.selected', '.buttons')
            .data('type');
          var target_url = 'https://maps.google.com/maps?q=' + encodeURIComponent(addressinfo.display);

          if (map_type == 'streetview' && latlng) {
            target_url += '&layer=c&cbll=' + latlng.join(',') + '&cbp=12,0,0,0,0';
          } else {
            target_url += '&t=' + (map_type == 'roadmap' ? 'm' : 'k');
          }

          target_url = Tracker([settings[map_type].dsid], [TRACKER_TYPE_MAP + 1], target_url);

          window.open(target_url, '_blank');
          return false;
        }),
    );

    // Construct map type buttons
    $('#map-container-buttons-template')
      .clone()
      .attr('id', '')
      .removeClass('hide')
      .find('[data-type=' + map_type + ']')
      .addClass('selected')
      .end()
      .find('li')
      .click(function() {
        var button_map_type = $(this).data('type');
        Tracker([settings[button_map_type].dsid], [TRACKER_TYPE_LINK + 1]);
        ShowMap($(this).closest('.map-container'), button_map_type);
      })
      .end()
      .appendTo(container);

    // Hide street view if no street available
    if (address_level > 2) {
      $(container)
        .find('.buttons li[data-type="streetview"]')
        .remove();
    }
  }

  function Tracker(dses, types, target_url) {
    var tracked_dses = [],
      tracked_types = [];

    // Check if already tracked this session
    for (var index = 0; index < dses.length; index++) {
      var trackid = dses[index] + '_' + types[index];
      if ($.inArray(trackid, tracked_map_views) < 0) {
        tracked_map_views.push(trackid);
        tracked_dses.push(dses[index]);
        tracked_types.push(types[index]);
      }
    }

    var url = '/rd/?S=' + P.search_id + '&DS=' + tracked_dses.join(',') + '&T=' + tracked_types.join(',');

    target_url = typeof target_url != 'undefined' ? target_url : null;
    if (target_url) {
      if (tracked_dses.length) {
        url += '&I=&U=' + encodeURIComponent(target_url);
      } else {
        url = target_url;
      }
      return url;
    }

    if (tracked_dses.length) {
      $.get(url);
    }
  }

  function initAutocomplete() {
    // autocomplete for filters
    $('#filter-add-loc').autocomplete({
      minLength: 2,
      delay: 70,
      autoFocus: true,
      source: P.C.getLocations,
      select: function(event, ui) {
        P.C.abortLastXHR();
        var form = $(this).parents('form');
        form.find('#adv_in').val('10');
        setfilter(ui.item.id, $(this));
      },
      search: function(event, ui) {
        removeFilter($(this));
      },
    });
  }

  function initAdvanced() {
    var $filters = $('div.filters');
    if ($filters.length) {
      //selected all(remove filters)
      $filters.find('input.all').on('change', function(e) {
        if ($(this).is(':checked')) {
          $(this)
            .closest('li')
            .addClass('selected')
            .closest('ul.first')
            .find('li.selected')
            .not('.all')
            .removeClass('selected')
            .find('input.filterselect')
            .removeAttr('checked');
          $(this)
            .parents('form')
            .submit();
        }
      });

      // fixing StripeIntegratedForm Saving in Browser, We will drop any saved checkbox by browser
      $('.filters input:checkbox')
        .not('[checked=checked]')
        .prop('checked', false);
      //selected filter
      $filters.find('input.filterselect').on('change', function(e) {
        var form = $(this).parents('form');
        window.CHECBOX_CHECKED = true;
        form.find('#adv_in').val($(this).attr('name') == 'floc' ? '10' : '11');

        if ($('#search_input_advanced_fields').length === 1) {
          $('#advanced_fields')
            .find('input[type=text]')
            .remove();
        }
        form.submit();
      });
    }

    var $input_labels = $('.inputs .input-label');
    if ($input_labels.length) {
      $input_labels.on('click', function() {
        $(this)
          .parent()
          .find('input')
          .focus();
      });
    }
  }

  // Click handler for "more >>" links in profile middle part and person preview
  function showMoreValues() {
    var element = $(this);
    if (this.nodeName == 'LI') {
      element.nextAll('.more-values').removeClass('more-values');
    } else {
      // Responsive "more Button"
      if (P.C.isMobileScreen()) {
        element
          .parents('.values')
          .find('li:not(.map-container)')
          .removeClass('more-values-mobile');
        element
          .parents('.values')
          .find('.more')
          .remove();
      } else {
        element.nextAll('.more-values').show();
      }
    }
    element.remove();
  }

  function initProfile() {
    $('#profile_container_middle')
      .find('.more')
      .on('click', showMoreValues);

    var $last_person_result = $('#unique_profile_records').find('.person_result:last');
    $last_person_result.attr('id', 'last_unique');
    var $showMoreProfileRecords = $('#show_more_profile_records');

    if ($showMoreProfileRecords.length) {
      $showMoreProfileRecords.on('click', function() {
        var margin;
        $('#more_profile_records').toggleClass('hidden');
        if ($('#more_profile_records').css('display') === 'none') {
          //hide
          margin = '30px';
          $(this)
            .removeClass('show-state')
            .addClass('hide-state');
        } else {
          //show
          margin = '50px';
          lazyLoaderManager.validatteAll();
          $(this)
            .removeClass('hide-state')
            .addClass('show-state');
        }

        if (!P.C.isMobileScreen()) $last_person_result.css('margin-bottom', margin);
        return false;
      });
    } else {
      $last_person_result.css('margin-bottom', '27px');
    }
  }

  function initPersonPreviews() {
    var $toggles = $('.person_preview_toggle');
    if ($toggles.length) {
      $toggles.on('click', function() {
        $(this)
          .parents('.person_preview_container')
          .toggleClass('dropup');
        $(this)
          .parents('.person_preview_container')
          .find('.person_preview')
          .toggleClass('hidden');
        return false;
      });
    }

    $('.person_preview')
      .find('.more')
      .on('click', showMoreValues);
  }

  function initMediaPools() {
    var $mediaPools = $('.media_pool');
    if ($mediaPools.length) {
      // lazy for media pool images
      // load first will load first X photos, and the rest only we user will trigger it
      $mediaPools.each(function() {
        var self = this;
        var ins = lazyLoaderManager.create({
          selector: 'img',
          src: 'data-src',
          loadFirst: 13,
          parentContainer: self,
          success: function(e) {
            if (this.imagesLoadSuccessfuly > 6 && typeof this.poolMediaLink == 'undefined') {
              var $self = $(self);
              var $allmedia = $self.parent().find('.allmedia');
              $allmedia.removeClass('hidden').show();
              $allmedia.find('.showallmedia').on('click', function() {
                $self.css({ height: 'auto', 'max-height': 'none' });
                $(this).remove();
                ins.loadAll = true;
                ins.validate();
                return false;
              });
              this.poolMediaLink = true;
            }
          },
          error: function(e) {
            $(e).remove();
          },
          finish: function(selector, count, count_success) {
            if (count_success == 0) {
              self.remove();
            }
          },
        });
      });
    }
    // lazy load for profile avatars
    var i = lazyLoaderManager.create({
      selector:
        '.profile_result_image.small .single_person,' +
        '.profile_result_image .avatar-thumb, ' +
        '.person_image .single_person.thumbnail, ' +
        '.profile_image .thumbnail',
      src: 'data-src',
      success: function(e) {
        $(e)
          .show()
          .css({ visibility: 'visible', display: 'block' });
        $(e)
          .parent()
          .find('.avatar')
          .remove();
        $(e)
          .parent()
          .find('.thumbnail-default')
          .remove();
      },
      error: function(e, i) {
        var cat_icon = $(e).data('category-icon');
        if (cat_icon) {
          $(e)
            .attr('src', cat_icon)
            .show();
          $(e)
            .show()
            .css('visibility', 'visible');
        } else {
          $(e).remove();
        }
      },
    });
  }

  function initMapsSections() {
    $('.values .addresses > li.link').on('click', function(e) {
      if (typeof $(this).attr('data-address') == 'undefined') {
        e.preventDefault();
        return false;
      }

      if (P.C.isMobileScreen()) {
        return true;
      } else {
        e.preventDefault();
      }

      // Mark triggering link as selected
      $(this)
        .toggleClass('selected')
        .siblings()
        .removeClass('selected');

      var container = $(this).nextAll('.map-container:first');
      container
        .toggleClass('map-appended')
        .siblings()
        .removeClass('map-appended');

      if (container.is(':visible')) {
        container.slideUp();
      } else {
        ShowMap(container, null, $(this).data('address'));
        container.siblings('.map-container').slideUp();
        container.slideDown();
      }
    });
  }

  function onMobileDevice() {
    $('div#advanced_search div.deepnc a.more').trigger('click');
  }

  this.init = function() {
    initAutocomplete();
    initAdvanced();
    initProfile();
    initPersonPreviews();
    initMediaPools();
    initMapsSections();

    $('div#advanced_search div.deepnc a.more').on('click', toggleView);
    $('div#advanced_search div.inputs')
      .not(':has(input[value!=""])')
      .not('.error')
      .children('input')
      .attr('disabled', 'disabled');

    // Add avatar class to search links
    $('.profile_result_content').each(function(indx, item) {
      var $item = $(item);
      var $img = $item.siblings('.profile_result_image');
      var $avatar = $img.find('div.avatar');
      if ($avatar.length) {
        var $avatar_class = $avatar.data('avatar');
        var $link = $item.find('div.title a');
        $link.attr('href', $link.attr('href') + '&avatar=' + $avatar_class);

        $link = $img.find('a');
        $link.attr('href', $link.attr('href') + '&avatar=' + $avatar_class);
      }
    });

    // Lazy Images Loader
    // simple load only, if no logic on error and success needed
    lazyLoaderManager.create({
      selector: '.profile_result_content.small img.favicon',
      src: 'data-src',
      error: function(e) {
        $(e).remove();
      },
    });

    if (P.C.isMobileScreen()) onMobileDevice();
  };
}

$(function() {
  P.S.init();
});
